import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import MobilityOptionsAddOptionModal from '../../containers/mobility-options/MobilityOptionsAddOptionModal'
import MobilityOptionsEditCategoryModal from '../../containers/mobility-options/MobilityOptionsEditCategoryModal'
import MobilityOptionsList from '../../containers/mobility-options/MobilityOptionsList'
import MobilityOptionsSearch from '../../containers/mobility-options/MobilityOptionsSearch'
import AddBtnIcon from '../icons/ui/AddBtn'
import ErrorBoundary from '../ErrorBoundary'

const MobilityOptionsPane = (props: RouteComponentProps<any>): any => {
  return (
    <ErrorBoundary>
      <section>
        <div className='bg-white'>
          <div className='pt3'>
            <div className='flex justify-between mb3 pl3'>
              <span className='h5 font-grey2'>MOBILITY DEVICES</span>
              <MobilityOptionsSearch />
            </div>
            <MobilityOptionsList />
          </div>
          <Route path={`${props.match.path}/add-category`} component={MobilityOptionsEditCategoryModal} />
          <Route path={`${props.match.path}/create-mobility-option`} component={MobilityOptionsAddOptionModal} />

          <div className='ml2 pl2 bold font-small'>
            <Link to={`/mobility-options/add-category`}>+ Add/Edit Category</Link>
          </div>
          <div className='absolute bottom-0 right-0 p4'>
            <Link to={`/mobility-options/create-mobility-option`}>
              <AddBtnIcon className='icon--64x64 cursor--pointer' />
            </Link>
          </div>
        </div>
      </section>
    </ErrorBoundary>
  )
}

export default MobilityOptionsPane



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsPane.tsx